import { collapseSection, expandSection } from "./questionnaire";

const panel = document.querySelector(".filter-list");
if (panel) {
    const inner = panel.querySelector<HTMLElement>(".filter-list-inner")!;
    panel.querySelectorAll(".filter-list-item").forEach(item => {
        item.addEventListener("click", () => {
            if (window.innerWidth <= 1050 && item.closest(".filter-list-mobile")) {
                // expand
                if (inner.classList.contains("expand")) {
                    // collapse
                    inner.classList.add('transitioning');
                    collapseSection(inner, () => {
                        inner.classList.remove('transitioning');
                        inner.classList.remove('expand');
                        console.log('col');
                    });
                } else {
                    inner.classList.add('transitioning');
                    expandSection(inner, () => {
                        inner.classList.add('expand');
                        console.log('exp');
                    });
                }
                return;
            };

            const value = item.getAttribute("value");
            panel.querySelectorAll(".filter-list-item").forEach(other => {
                const subValue = other.getAttribute("value");
                other.classList.toggle("active", value === subValue);
            });
            if (window.innerWidth <= 1050) {
                // collapse
                inner.classList.add('transitioning');
                collapseSection(inner, () => {
                    inner.classList.remove('expand');
                    inner.classList.remove('transitioning');
                });
            }
        })
    });
}
export default undefined;
